<h1 class="matp-page-title">テナント設定 {{ tenantId }}</h1>

<!-- タブ切替 -->
<div class="tw-my-2">
  <mat-button-toggle-group
    class="matp-button-toggle-group"
    aria-label="表示種類"
    [hideSingleSelectionIndicator]="'true'"
    [(ngModel)]="selectedDisplayType"
  >
    <mat-button-toggle class="tw-w-44" value="apiKey"
      >API Key</mat-button-toggle
    >
    <mat-button-toggle class="tw-w-44" value="tag"
      >タグ追加・削除</mat-button-toggle
    >
    <mat-button-toggle class="tw-w-44" value="alertNotification"
      >メールアラート通知</mat-button-toggle
    >
    <mat-button-toggle class="tw-w-44" value="backupMail"
      >バックアップメール</mat-button-toggle
    >
    <mat-button-toggle class="tw-w-44" value="notificationMail"
      >掲示板メール</mat-button-toggle
    >
  </mat-button-toggle-group>
</div>

<mat-card
  class="matp-card !tw-min-w-[800px] tw-max-w-[60%]"
  *ngIf="selectedDisplayType === 'apiKey'"
>
  <app-tenant-setting-api-key
    [webhook]="webhook"
    class="tw-p-3"
    [apikey]="apikey"
    (created)="openApikeyEditDialog()"
    (updated)="openWebhookEditDialog($event)"
    (webhookDeleted)="openWebhookDeleteDialog($event)"
    (deleted)="deleteApikey()"
  >
  </app-tenant-setting-api-key>
</mat-card>

<mat-card
  class="matp-card !tw-min-w-[800px] tw-max-w-[60%]"
  *ngIf="selectedDisplayType === 'notificationMail'"
>
  <app-tenant-setting-backup
    class="tw-p-3"
    heading="掲示板メール送信先メールアドレス"
    tooltipText="掲示板メッセージの公開後、定期処理で下記のメールアドレスへ通知します。公開からメール送信まで時間がかかる場合があります。"
    [backupEmailStr]="notificationEmailStr"
    [webhook]="webhook"
    (updated)="updateNotificationEmail($event)"
  >
  </app-tenant-setting-backup>
</mat-card>

<mat-card
  class="matp-card !tw-min-w-[800px] tw-max-w-[60%]"
  *ngIf="selectedDisplayType === 'tag'"
>
  <app-tenant-setting-tag
    [tagList]="tagList"
    [selection]="selection"
    (created)="openTagEditDialog()"
    (updated)="openTagEditDialog($event)"
    (deleted)="deleteTag($event)"
  >
  </app-tenant-setting-tag>
</mat-card>

<mat-card
  class="matp-card !tw-min-w-[800px] tw-max-w-[60%]"
  *ngIf="selectedDisplayType === 'alertNotification'"
>
  <app-tenant-setting-notification
    [tenantAlert]="tenantAlert"
    [originalTenantAlert]="originalTenantAlert"
    [tagList]="tagList"
    (updated)="updateTenantAlert($event[0], $event[1])"
  >
  </app-tenant-setting-notification>
</mat-card>

<mat-card
  class="matp-card !tw-min-w-[800px] tw-max-w-[60%]"
  *ngIf="selectedDisplayType === 'backupMail'"
>
  <app-tenant-setting-backup
    class="tw-p-3"
    [backupEmailStr]="backupEmailStr"
    [webhook]="webhook"
    (updated)="updateBackupEmail($event)"
  >
  </app-tenant-setting-backup>
</mat-card>
